import React from 'react';
import { CheckIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { METHOD, PRODUCT } from '../data/constants';
export function SystemSection() {
  return <section className="bg-ice py-5 sm:py-7" data-id="element-171" data-mp="3bimxngbqr96h">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-172" data-mp="3bhloxii76yrx">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-173" data-mp="36k2605ak1xtn">
          LE SYSTÈME PROFESSIONNEL <span className="text-tech-dark" data-id="element-174" data-mp="31l8ugietwgw4">COMPLET 6 EN 1</span>
        </h2>
        <p className="mt-1.5 text-center font-display text-sm font-semibold uppercase tracking-wide text-tech-dark sm:text-lg" data-id="element-175" data-mp="2wu0ipfq10jfs">
          Ce qui est inclus
        </p>

        <div className="mx-auto mt-3 max-w-4xl rounded-xl border-2 border-navy bg-white p-3 text-center shadow-sm sm:p-5" data-id="element-176" data-mp="2ssnd96quii9e">
          <p className="font-heading text-lg font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-177" data-mp="2nrhil3dmkkx8">
            🌿 {PRODUCT}
          </p>
          <p className="mt-1.5 text-sm leading-snug text-steel sm:text-base" data-id="element-178" data-mp="2dw63ul27vdph">
            Le système professionnel complet pour identifier les carences nutritionnelles,
            interpréter les symptômes végétaux et prendre des décisions éclairées : fondamentaux,
            atlas des carences, sol et pH, diagnostic visuel et analyses, nutrition par culture,
            plan d’action et protocoles de terrain. Pas six livres théoriques : un système prêt à
            l’emploi.
          </p>
          <p className="mx-auto mt-2 w-fit max-w-full rounded-lg bg-navy px-3 py-1 font-display text-2xs font-bold uppercase tracking-wide text-white sm:text-sm" data-id="element-179" data-mp="1mqr23kq5a8u2">
            {METHOD.map((step, i) => <React.Fragment key={step} data-id="element-180" data-mp="1cqqdbj9ib0ih" data-mpi={i}>
                {i > 0 && ' › '}
                <span className={i % 2 === 1 ? 'text-tech-light' : ''} data-id="element-181" data-mp="1hq38qseg1fwo">{step}</span>
              </React.Fragment>)}
          </p>
        </div>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-182" data-mp="1eh6zz5kril7">
          {modules.map(module => <article key={module.title} className={`rounded-xl border bg-white p-3 shadow-sm sm:p-4 ${module.featured ? 'border-alert ring-2 ring-alert/40 md:col-span-2 md:order-first' : 'border-metal'}`} style={{
          borderLeft: `6px solid ${module.color}`
        }} data-id="element-183" data-mp="69391bprnysm">
              {module.featured && <p className="mb-1.5 w-fit rounded-md bg-alert px-2 py-0.5 font-display text-2xs font-extrabold uppercase tracking-wide text-navy sm:text-xs" data-id="element-184" data-mp="1p9vt1ie6n2q9">
                  ⭐ Le module central du système
                </p>}
              <h3 className="flex items-start gap-1.5 text-sm leading-tight text-navy sm:text-base" data-id="element-185" data-mp="1ga8q2s5t1ov3">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" strokeWidth={3} aria-hidden="true" data-id="element-186" data-mp="1bbxf2e3rx8ba" />
                {module.title}
              </h3>
              <p className="mt-1 text-sm leading-snug text-steel" data-id="element-187" data-mp="35mklojkdj2hn">{module.body}</p>
              <p className="mt-1 font-display text-xs font-bold uppercase text-tech-dark" data-id="element-188" data-mp="3d7mt53pfgd33">
                {module.tagline}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}